import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin, Alert } from "antd";
import Invoice from "../components/FeeInvoice";
import { useTranslation } from "react-i18next";
import useFee from "../hooks/useFee";

const FeeInvoice: React.FC = () => {
  const { feeId } = useParams<{ feeId: string }>();

  const { t } = useTranslation();
  const [feeData, setFeeData] = useState<any>(null);

  const { handleGetFeeById, loading, error } = useFee();

  useEffect(() => {
    console.log(feeId);
    if (feeId) {
      handleGetFeeById(feeId).then((response) => {
        setFeeData(response);
      });
    }
  }, [feeId]);

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Spin />
        </div>
      </div>
    );
  }

  if (error || !feeData) {
    return (
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Alert
            message={t("error")}
            description={t("failed_to_fetch_fees")}
            type="error"
            showIcon
          />
        </div>
      </div>
    );
  }

  return <Invoice data={feeData} />;
};

export default FeeInvoice;
